<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.833 7.99992C14.2932 7.99992 14.6717 7.62538 14.6143 7.16873C14.4857 6.14472 14.1204 5.16055 13.5428 4.29612C12.8103 3.19979 11.7691 2.34531 10.5509 1.84072C9.33272 1.33614 7.99228 1.20412 6.69907 1.46135C5.40587 1.71858 4.21798 2.35352 3.28563 3.28587C2.35328 4.21822 1.71834 5.40611 1.46111 6.69932C1.20387 7.99252 1.33589 9.33297 1.84048 10.5511C2.34506 11.7693 3.19955 12.8105 4.29587 13.543C5.1603 14.1206 6.14447 14.4859 7.16849 14.6146C7.62514 14.672 7.99967 14.2935 7.99967 13.8333C7.99967 13.373 7.62404 13.007 7.17018 12.9306C6.47645 12.8139 5.81194 12.5516 5.22182 12.1573C4.39958 11.6079 3.75872 10.827 3.38028 9.91334C3.00184 8.99971 2.90282 7.99437 3.09575 7.02447C3.28867 6.05456 3.76488 5.16365 4.46414 4.46439C5.1634 3.76512 6.05432 3.28892 7.02422 3.09599C7.99413 2.90307 8.99946 3.00208 9.91309 3.38052C10.8267 3.75896 11.6076 4.39982 12.157 5.22207C12.5513 5.81218 12.8137 6.4767 12.9304 7.17042C13.0067 7.62428 13.3728 7.99992 13.833 7.99992Z"
            fill="url(#paint0_linear_3075_20830)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_3075_20830"
                x1="0.330552"
                y1="1.33325"
                x2="15.6688"
                y2="14.6666"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.0224" stop-color="#DEA5FA" />
                <stop offset="0.9697" stop-color="#733FE0" />
            </linearGradient>
        </defs>
    </svg>
</template>
